import { NeverObservable } from './NeverObservable';
export var never = NeverObservable.create;
//# sourceMappingURL=never.js.map